// extracted by mini-css-extract-plugin
export var alignBaseline = "_s-9";
export var alignCenter = "_s-5";
export var alignFlexEnd = "_s-7";
export var alignFlexStart = "_s-6";
export var alignSelfBaseline = "_s-e";
export var alignSelfCenter = "_s-a";
export var alignSelfFlexEnd = "_s-c";
export var alignSelfFlexStart = "_s-b";
export var alignSelfStretch = "_s-d";
export var alignStretch = "_s-8";
export var column = "_s-2";
export var columnReverse = "_s-4";
export var flex = "_s-0";
export var justifyCenter = "_s-f";
export var justifyFlexEnd = "_s-h";
export var justifyFlexStart = "_s-g";
export var justifySpaceAround = "_s-j";
export var justifySpaceBetween = "_s-i";
export var justifySpaceEvenly = "_s-k";
export var row = "_s-1";
export var rowReverse = "_s-3";
export var wrapNowrap = "_s-m";
export var wrapWrap = "_s-l";
export var wrapWrapReverse = "_s-n";